import { getClassUrl } from '../../utils/classes';

import CoachClassCard from './CoachClassCard';
import { type GenerateCoachClassCardsAllEventsFragment } from './__generated-gql-types__/GenerateCoachClassCards.generated';

interface GenerateCoachClassCardsProps {
  classes: GenerateCoachClassCardsAllEventsFragment[];
}

const GenerateCoachClassCards: React.FC<GenerateCoachClassCardsProps> = ({
  classes,
}) => {
  return classes.map((c) => {
    if (c.__typename === 'Class') {
      const [firstSession, ...otherSessions] = c.upcomingSessionsV2 ?? [];

      return (
        <CoachClassCard
          key={c.classId}
          name={c.name ?? ''}
          imageLink={c.imageLink ?? ''}
          date={firstSession?.startAt ?? 0}
          durationInMinute={firstSession?.durationInMinute ?? 0}
          link={getClassUrl(c.slug ?? '', c.price === 0 || c.price === null)}
          otherSessions={otherSessions}
          price={c.price}
        />
      );
    } else if (c.__typename === 'Shindig') {
      return (
        <CoachClassCard
          key={c.shindigId}
          name={c.shindigName}
          imageLink={c.imageLink ?? ''}
          date={c.date}
          durationInMinute={c.durationInMinute}
          link={c.link}
        />
      );
    }

    return null;
  });
};

export default GenerateCoachClassCards;
